import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../common/Modal/Modal';
import ConfirmAPIKeyModal from '../ConfirmApiKeyModal/ConfirmAPIKeyModal';
var NewApiKeyModal = function NewApiKeyModal(props, context) {
  return React.createElement(Modal, {
    isOpen: props.isOpen,
    title: context.t('Create New API Key'),
    customClass: 'retail-api-keys-modal',
    onCancel: function onCancel() {
      props.removeApiKey(props.apiKey.APIKey);
      props.close();
    },
    close: props.close,
    footer: {
      buttonText: context.t('Confirm'),
      buttonStyle: 'additive',
      onClick: function onClick() {
        return props.addApiKey(props.apiKey);
      }
    }
  }, React.createElement(ConfirmAPIKeyModal, {
    item: props.apiKey,
    userId: props.userId,
    index: props.numberOfApiKeys
  }));
};
NewApiKeyModal.propTypes = {
  apiKey: PropTypes.object,
  userId: PropTypes.number.isRequired,
  numberOfApiKeys: PropTypes.number.isRequired,
  addApiKey: PropTypes.func.isRequired,
  removeApiKey: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired
};
NewApiKeyModal.contextTypes = {
  t: PropTypes.func.isRequired
};
export default NewApiKeyModal;